module.exports = __webpack_public_path__ + "static/img/types_xs.354a3764.png";